import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { BikeMissingData } from './pages/contracts/BikeMissingData.loadable';
import { BikeThankYou } from './pages/contracts/BikeThankYou.loadable';
import { Bike } from './Bike.loadable';

function BikeRouter(props: any) {
  return (
    <Switch>
      <Route
        exact
        path={`${props.match.path}/contracts/:contractId/missing-data`}
      >
        <BikeMissingData rootUrl={`${props.match.path}/contracts`} />
      </Route>
      <Route exact path={`${props.match.path}/contracts/thank-you`}>
        <BikeThankYou />
      </Route>
      <Route path={props.match.path}>
        <Bike {...props} />
      </Route>
    </Switch>
  );
}

export default BikeRouter;
